import { diningActions } from '../actions';
import { locationToMarker } from '../../../common/utils';

const initialState = {
  error: false,
  loaded: false,
  locations: [],
  markers: []
};

export default (state = initialState, action) => {
  switch (action.type) {
    case diningActions.GET_DINING:
      return {
        ...state,
        error: false
      };

    case diningActions.GET_DINING_FAIL:
      return {
        ...state,
        error: true
      };

    case diningActions.GET_DINING_SUCCESS:
      const locations = action.payload;

      return {
        ...state,
        loaded: true,
        markers: locationToMarker(locations),
        locations: [...locations]
      };

    default:
      return state;
  }
};
